import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Anchor from '../Anchor/Anchor';
import Paragraph from '../Paragraph/Paragraph';
import SingleColumnList from '../TwoColumnList/SingleColumnList';
import config from '../../config';
import Button from '../Button/Button';
import { useLiveChat } from '../../util/hooks/useLiveChat';

const LiveChatButton = styled(Button)`
  font-size: 14px;
  text-transform: capitalize;
  text-decoration: underline;
`;

const SupportLinks = ({ brokerSettings, isLPM }) => {
  const { t } = useTranslation();
  const { startLiveChat } = useLiveChat();
  const { brokerTheme } = config;
  const isHAA = brokerTheme === 'HardAssetsAlliance';

  if (!brokerSettings) {
    return null;
  }

  const {
    FrequentlyAskedQuestionsUrl,
    SupportLiveChatUrl,
    SupportEmail,
    SupportPhoneTollFree,
    SupportPhoneInternational,
  } = brokerSettings;

  return (
    <SingleColumnList textAlignLeft>
      {!isLPM && FrequentlyAskedQuestionsUrl && (
        <>
          <Paragraph bold marginBottom={4}>
            {t(`support.supportCenter`)}
          </Paragraph>
          <Anchor
            bold
            marginBottom={32}
            type="website"
            value={FrequentlyAskedQuestionsUrl}
            text={t(`support.browseQuestions`)}
          />
        </>
      )}
      {SupportLiveChatUrl && (
        <>
          <Paragraph bold marginBottom={4}>
            {t(`support.chatWithAgents`)}
          </Paragraph>
          <Anchor
            bold
            type="website"
            marginBottom={32}
            value={SupportLiveChatUrl}
            text={t(`support.browseQuestions`)}
          />
        </>
      )}
      {SupportEmail && (
        <>
          <Paragraph bold marginBottom={4}>
            {t(`support.emailUs`)}
          </Paragraph>
          <Anchor
            bold
            type="email"
            marginBottom={32}
            value={SupportEmail}
            text={SupportEmail}
          />
        </>
      )}

      <Paragraph bold marginBottom={4}>
        {t(`support.callUs`)}
      </Paragraph>
      {SupportPhoneTollFree && (
        <Paragraph bold>
          {t(`support.toll`)}
          &nbsp;
          <Anchor
            type="telephone"
            value={SupportPhoneTollFree}
            text={SupportPhoneTollFree}
          />
        </Paragraph>
      )}
      {SupportPhoneInternational && (
        <Paragraph bold>
          {t(`support.tollInternational`)}
          &nbsp;
          <Anchor
            type="telephone"
            value={SupportPhoneInternational}
            text={SupportPhoneInternational}
          />
        </Paragraph>
      )}

      {!isHAA && (
        <Paragraph bold marginBottom={4} marginTop={32}>
          {t(`support.liveChat`)}
          &nbsp;
          <LiveChatButton variant="primaryClear" onClick={startLiveChat}>
            {t('support.chatWithTeam')}
          </LiveChatButton>
        </Paragraph>
      )}
    </SingleColumnList>
  );
};

SupportLinks.propTypes = {
  brokerSettings: PropTypes.shape({
    FrequentlyAskedQuestionsUrl: PropTypes.string,
    SupportLiveChatUrl: PropTypes.string,
    SupportEmail: PropTypes.string,
    SupportPhone: PropTypes.string,
    SupportPhoneTollFree: PropTypes.string,
    SupportPhoneInternational: PropTypes.string,
  }),
  isLPM: PropTypes.bool,
};

export default SupportLinks;
